export const enum Children {
  RENEW = 'renovacao',
  RENEW_DCC = 'atualizacaodcc',
}

export enum TypesOfProducts {
  Plan = 1,
  Income,
}
